export type DiscoveryState = string;

export const DISCOVERY_SEARCHED_STATE = 'searched';

export const isDiscoverySearched = (state: string) => state === DISCOVERY_SEARCHED_STATE;

export type DiscoveryCreatorSort = 'rank' | 'followers_count' | 'average_views';

export const DISCOVERY_CREATOR_SORT_LABELS: Record<DiscoveryCreatorSort, string> = {
    rank: 'Relevance',
    followers_count: 'Followers',
    average_views: 'Avg Views',
};

export const DISCOVERY_CREATOR_SORT_ORDER: DiscoveryCreatorSort[] = [
    'rank',
    'followers_count',
    'average_views',
];

export const getNextDiscoveryCreatorSort = (current: DiscoveryCreatorSort): DiscoveryCreatorSort => {
    const index = DISCOVERY_CREATOR_SORT_ORDER.indexOf(current);
    return DISCOVERY_CREATOR_SORT_ORDER[(index + 1) % DISCOVERY_CREATOR_SORT_ORDER.length];
};

export interface RecentDiscovery {
    uuid: string;
    query: string;
    created: string;
}

export interface RecentDiscoveriesResponse {
    items: RecentDiscovery[];
    count: number;
}

export interface DiscoveryDetails {
    uuid: string;
    query: string;
    state: DiscoveryState;
}

export interface DiscoveredCreatorIg {
    age_bucket?: string;
    gender?: string;
}

export interface DiscoveredCreator {
    uuid: string;
    name: string;
    profile_picture_url: string | null;
    platform: string;
    handle: string;
    engagement_score: string;
    followers_count: number;
    average_views: number;
    mobile: string | null;
    ig?: DiscoveredCreatorIg;
}

export interface DiscoveredCreatorsResponse {
    items: DiscoveredCreator[];
    count: number;
}

export interface DiscoverCreatorsResponse {
    status: boolean;
    uuid: string;
}

export interface RecommendedCreatorsResponse extends DiscoveredCreatorsResponse {}

export interface RecommendedCreatorsFilters {
    page: number;
    sort: DiscoveryCreatorSort;
}

export interface RecommendedCreatorsSlice {
    error: string | null;
    loading: boolean;
    campaigns: Record<
        string,
        {
            filtered_lists: Record<
                string,
                {
                    count: number;
                    list: DiscoveredCreator[];
                    page: number;
                    has_more: boolean;
                    last_fetched_at: number;
                    filters: RecommendedCreatorsFilters;
                }
            >;
        }
    >;
    applied_filter_id: string | null;
    filters: RecommendedCreatorsFilters;
}
